module.exports = __webpack_public_path__ + "img/logo-fa-botton-white.3db9a26.svg";